import { Injectable } from '@angular/core';
import { HttpMethodType } from '@app/app.constant';
import { HttpCallService } from '@app/core/services/http-call.service';
import { INotificationRuleParameterHttpResponse, NotificationRuleParameter } from '@app/models/notification-settings';
import { map } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

const HttpServiceMethods = {
  NotificationRule: 'NotificationRuleParameter'
};
@Injectable({
  providedIn: 'root'
})
export class NotificationRuleParametersService {
  constructor(private httpService: HttpCallService) { }

  public list(notificationRuleId: number): Observable<NotificationRuleParameter[]> {
    return this.httpService
      .callService(HttpMethodType.GET, `${HttpServiceMethods.NotificationRule}/GetNotificationRuleParameterList/${notificationRuleId}`)
      .pipe(
        map((res) => res.map((item: INotificationRuleParameterHttpResponse) => NotificationRuleParameter.adapt(item)))
      );
  }

  public get(id: number): Observable<NotificationRuleParameter> {
    return this.httpService
      .callService(HttpMethodType.GET, `${HttpServiceMethods.NotificationRule}/${id}`)
      .pipe(map((item: INotificationRuleParameterHttpResponse) => NotificationRuleParameter.adapt(item)));
  }

  public add(notificationRuleParameter: NotificationRuleParameter) {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.NotificationRule,
      notificationRuleParameter
    );
  }

  public update(notificationRuleParameter: NotificationRuleParameter) {
    return this.httpService.callService(
      HttpMethodType.PUT,
      HttpServiceMethods.NotificationRule,
      notificationRuleParameter
    );
  }

  public delete(id: number) {
    return this.httpService.callService(
      HttpMethodType.DELETE,
      `${HttpServiceMethods.NotificationRule}/${id}`
    );
  }
}
